class ToggleOpen {
    constructor(el) {
        this.scope = el;
        const targetSelector = this.scope.getAttribute('data-toggle-open');
        this.target = document.querySelector(targetSelector);

        if (this.target) {
            this.bindEvents();
        }
    }

    bindEvents() {
        this.scope.addEventListener('click', (e) => {
            e.preventDefault();
            this.target.classList.toggle("open");
        });
    }
}

ControlBinders.register("[data-toggle-open]", elm => new ToggleOpen(elm));